// based on rc-time-picker 3.4.0
export { default } from './TimePicker';


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-time-picker/index.js
// module id = 685
// module chunks = 16